export default {
	name: 'moral-education',
	path: '/moral-education',
	meta: {
		title: '五育应用'
	},
	redirect: '/daily-evaluation',
	children: [
		{
			name: 'daily-evaluation',
			path: '/daily-evaluation',
			meta: {
				title: '日常评价'
			},
			redirect: '/performance-evaluation',
			component: () =>
				import(/* webpackChunkName: "school-finance" */ '@/views/daily-evaluation'),
			children: [
				{
					name: 'performance-evaluation',
					path: '/performance-evaluation',
					// meta: {
					// 	title: '表现评价'
					// },
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/daily-evaluation/performance-evaluation')
				},
				{
					name: 'growth-indicator-system',
					path: '/growth-indicator-system',
					// meta: {
					// 	title: '成长指标体系'
					// },
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/daily-evaluation/growth-indicator-system')
				},
				{
					name: 'data-center',
					path: '/data-center',
					// meta: {
					// 	title: '数据中心'
					// },
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/daily-evaluation/data-center')
				},
				{
					name: 'personal-evaluation',
					path: '/personal-evaluation',
					// meta: {
					// 	title: '查看评价'
					// },
					component: () =>
						import(/* webpackChunkName: "school-finance" */ '@/views/daily-evaluation/personal-evaluation')
				}
			]
		}
	]
};
